<template>
  <div v-bind:class="{paused: paused}" v-on:tap="togglePlay()" class="play-button">
    <img v-bind:src="getPlayerButtonImage" />
  </div>
</template>
<script>
import enums from '../enums/RdsLife.enums';
import playerService from '../services/Player.service';
const PLAY_IMG = require('../assets/images/playernoop.svg');
const PAUSE_IMG = require('../assets/images/icona_pausa.svg');
const LOAD_IMG = require('../assets/images/icona_pausa.svg');

export default {
  name: 'rds-player',
  data() {
    return {
      playerService: playerService
    };
  },
  computed: {
    getPlayerButtonImage: function() {
      console.log(playerService.status);
      if (playerService.status === enums.playerStatuses.PAUSED) {
        return PLAY_IMG;
      } else if (playerService.status === enums.playerStatuses.WAITING) {
        return LOAD_IMG;
      } else {
        return PAUSE_IMG;
      }
    },
    paused: function() {
      return playerService.status === enums.playerStatuses.PAUSED;
    }
  },
  methods: {
    togglePlay: () => playerService.togglePlay()
  }
};
</script>
<style lang="scss" scoped>
.play-button {
  display: flex;
  img {
    margin: 0 auto;
    width: 65px;
    height: 65px;
  }
}
</style>
